import { Pipe, PipeTransform, inject } from '@angular/core';
import {
  getResultDisciplineDefinition,
  normalizeResultDiscipline,
} from '../models/discipline.models';
import { TranslationService } from '../services/translation.service';

@Pipe({
  name: 'disciplineLabel',
  standalone: true,
  pure: false,
})
export class DisciplinePipe implements PipeTransform {
  private readonly translationService = inject(TranslationService);

  transform(value?: string | null, fallback = ''): string {
    if (!value) return fallback.includes('.')
      ? this.translationService.translate(fallback)
      : fallback;
    const discipline = normalizeResultDiscipline(value);
    if (!discipline) return value;

    const definition = getResultDisciplineDefinition(discipline);
    return this.translationService.translate(definition.labelKey);
  }
}
